import type { AppState } from '@/types'

export const getPreviewColor = (state: AppState, id: string): string | null => {
  const { canvas } = state

  return canvas.previewColor ? canvas.previewColor[id] : null
}
